import { api } from './api';
import {
  NotificationPreferenceApiResponse,
  NotificationPreferenceCategory,
  NotificationPreferenceValue,
} from '../types/NotificationPreferenceModels';

const normalizePreferenceValue = (
  response: NotificationPreferenceApiResponse
): string => {
  if (typeof response.enabled === 'boolean') {
    return response.enabled
      ? NotificationPreferenceValue.Enabled
      : NotificationPreferenceValue.Disabled;
  }

  if (typeof response.isEnabled === 'boolean') {
    return response.isEnabled
      ? NotificationPreferenceValue.Enabled
      : NotificationPreferenceValue.Disabled;
  }

  const firstStringValue =
    response.value ?? response.status ?? response.preference ?? '';

  if (typeof firstStringValue === 'string') {
    return firstStringValue.toLowerCase();
  }

  return '';
};

export const isNotificationPreferenceEnabled = (
  response: NotificationPreferenceApiResponse
): boolean => {
  const normalized = normalizePreferenceValue(response);

  if (normalized === NotificationPreferenceValue.Disabled) {
    return false;
  }

  // Empty values and "enabled" should both map to ON per requirements.
  return true;
};

export const getAllNotificationPreferences = async (): Promise<Record<string, boolean>> => {
  try {
    const response = await api.get<Record<string, boolean>>('/v1/notification/preferences');
    return response.data;
  } catch (error) {
    console.error('Error fetching all notification preferences:', error);
    throw error;
  }
};

export const getNotificationPreference = async (
  category: NotificationPreferenceCategory
): Promise<NotificationPreferenceApiResponse> => {
  try {
    const response = await api.get<NotificationPreferenceApiResponse>(
      `/v1/notification/preferences/${category}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching notification preference:', error);
    throw error;
  }
};

export const toggleNotificationPreference = async (
  category: NotificationPreferenceCategory,
  enabled: boolean
): Promise<void> => {
  try {
    await api.post(`/v1/notification/preferences/${category}/toggle`, null, {
      params: {
        enabled,
      },
    });
  } catch (error) {
    console.error('Error toggling notification preference:', error);
    throw error;
  }
};
